/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from '@mui/material';
import { useConfirmLessonShareHook } from './hooks/useConfirmLessonShareHook';

export const ConfirmLessonShare = () => {
    const {} = useConfirmLessonShareHook();

    return <Box></Box>;
};
